import { Show, useContext } from 'solid-js';
import { Text } from '../../ui-components/text/text';
import { AppContext } from '../../app-context-provider/app-context-provider';
import theme from '../../style/theme';
import { OrderDetails } from './user-order-history';
import { ImageComponent } from '../image-component/image-component';
import { Link } from '../../ui-components/link/link';
import { VerticalSpace } from '../../ui-components/utility-style-components/spacing';
import { useNavigate } from '@solidjs/router';


type OrderHistoryOrderlineProps = {
    orderDetails: OrderDetails;
    lastElement: (el: any) => void;
};

const OrderHistoryOrderline = (props: OrderHistoryOrderlineProps) => {
    const { viewport, localize, productsEntityName, appStore } = useContext(AppContext);
    const { closeLoginMenu } = appStore;

    const navigate = useNavigate();

    const isDesktop = () => viewport.width > theme.breakpoints.ORIGINAL_TABLET;

    return (
        <div class="flex gap-4 items-center">
            <div class="flex gap-4">

                <div class="shrink-0 self-start w-[100px] pr-4 max-tablet:mb-6 max-tablet:pr-0 max-tablet:w-[60px]">
                    <Show when={props.orderDetails.imageUrl}>
                        <ImageComponent
                            src={props.orderDetails.imageUrl!}
                            height={'AUTO'}
                            width={300}
                            altText={'Product image for ' + props.orderDetails.skuName}
                            aspectRatio={'original'}
                            ratio={props.orderDetails.imageRatio}
                        />
                    </Show>
                </div>

                <div class="flex flex-col items-start">
                    <Link
                        url=''
                        asButton
                        label={`${props.orderDetails.amount} x ${props.orderDetails.skuName}`}
                        noBlockSpacing
                        customCss='text-align: left;'
                        onClick={() => {
                            navigate(`/${productsEntityName}/${props.orderDetails.slug}`);
                            closeLoginMenu();
                        }}
                        element={(el: HTMLButtonElement) => props.lastElement(el)}
                    />
                    <VerticalSpace size={0.5} />
                    <Text fontSize='small' noBlockSpacing color='gray' lineLimit={isDesktop() ? 2 : 3}>{
                        props.orderDetails.skuDescription
                    }</Text>
                    <Text fontSize='small' color='gray' noBlockSpacing>{
                        `${props.orderDetails.skuQuantity ? `${localize('units-per-pack', 'Units per pack')}: ${props.orderDetails.skuQuantity}` : ''}`
                    }</Text>
                </div>

            </div>
        </div>
    );
};

export default OrderHistoryOrderline;
